import { environment } from "../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";

export function getApiUrl(path: string = "") {
  var prefix = environment.apiURL.slice(-1) == "/" ? "api/" : "/api/"; //.backendUrl

  path = path.charAt(0) == "/" ? path.substring(1) : path;

  return environment.apiURL + prefix + path; //.backendUrl
}

export function getUnprotectedPaths() {
  return [
    'Settings/theme',
    'Settings/app-info',
    'Settings/get-company-image',
    // 'Employee/employee',
  ];
}

export class BaseService {
  constructor(public http: HttpClient) {}

  getApiUrl(path: string) {
    return getApiUrl(path);
  }

  getUnprotectedPaths() {
    return getUnprotectedPaths();
  }
}
